import { render } from "@wordpress/element";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

window.addEventListener("DOMContentLoaded", () => {
	const PRICE_ROUTE = "https://app.taxdown.es/signup";
	const settings = {
		dots: true,
		infinite: false,
		adaptiveHeight: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		className: "my-plans-slide",
		centerMode: true,
	};

	let counter = 0;

	const LogoYellow = () => {
		const prefix = () => {
			counter += 1;
			return `paint-${counter}_linear_292_12953`;
		};
		const id1 = prefix() + "_1";
		const id2 = prefix() + "_2";
		const id3 = prefix() + "_3";
		const urlId1 = `url(#${id1})`;
		const urlId2 = `url(#${id2})`;
		const urlId3 = `url(#${id3})`;
		return (
			<svg
				width="40"
				height="27"
				viewBox="0 0 40 27"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M6.3397 0.989949C6.88643 0.443215 7.77286 0.443215 8.3196 0.989949L12.2794 4.94975C12.8261 5.49648 12.8261 6.38291 12.2794 6.92965L7.32965 11.8794C6.78291 12.4261 5.89648 12.4261 5.34975 11.8794L1.38995 7.9196C0.843216 7.37286 0.843216 6.48643 1.38995 5.9397L6.3397 0.989949Z"
					fill={urlId1}
				></path>
				<path
					d="M19.5385 1.79097C20.0853 1.24424 20.9717 1.24424 21.5184 1.79097L25.4782 5.75077C26.025 6.29751 26.025 7.18394 25.4782 7.73067L14.3294 18.8795C13.7827 19.4262 12.8963 19.4262 12.3495 18.8795L8.38973 14.9197C7.843 14.3729 7.843 13.4865 8.38974 12.9398L19.5385 1.79097Z"
					fill={urlId2}
				></path>
				<path
					d="M32.8631 2.46822C33.4099 1.92149 34.2963 1.92149 34.843 2.46822L38.8028 6.42802C39.3496 6.97475 39.3496 7.86118 38.8028 8.40792L21.3314 25.8794C20.7846 26.4261 19.8982 26.4261 19.3515 25.8794L15.3917 21.9196C14.8449 21.3729 14.8449 20.4864 15.3917 19.9397L32.8631 2.46822Z"
					fill={urlId3}
				></path>
				<defs>
					<linearGradient
						id={id1}
						x1="10.2995"
						y1="2.96985"
						x2="3.36985"
						y2="9.8995"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="#FFF38A"></stop>
						<stop offset="1" stopColor="#FFC700"></stop>
					</linearGradient>
					<linearGradient
						id={id2}
						x1="23.4983"
						y1="3.77087"
						x2="10.3696"
						y2="16.8996"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="#FFF38A"></stop>
						<stop offset="1" stopColor="#FFC700"></stop>
					</linearGradient>
					<linearGradient
						id={id3}
						x1="36.8229"
						y1="4.44812"
						x2="17.3716"
						y2="23.8995"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="#FFF38A"></stop>
						<stop offset="1" stopColor="#FFC700"></stop>
					</linearGradient>
				</defs>
			</svg>
		);
	};

	const basic = (price) => {
		return (
			<div className="home-plan-box basic">
				<svg
					width="40"
					height="27"
					viewBox="0 0 40 27"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M6.3397 0.989949C6.88644 0.443215 7.77287 0.443216 8.3196 0.989949L12.2794 4.94975C12.8261 5.49648 12.8261 6.38291 12.2794 6.92965L7.32965 11.8794C6.78292 12.4261 5.89649 12.4261 5.34975 11.8794L1.38995 7.9196C0.84322 7.37286 0.84322 6.48643 1.38995 5.9397L6.3397 0.989949Z"
						fill="#2F2E46"
					></path>
					<path
						d="M19.5385 1.79097C20.0853 1.24424 20.9717 1.24424 21.5184 1.79097L25.4782 5.75077C26.025 6.29751 26.025 7.18394 25.4782 7.73067L14.3294 18.8795C13.7827 19.4262 12.8963 19.4262 12.3495 18.8795L8.38973 14.9197C7.843 14.3729 7.843 13.4865 8.38973 12.9398L19.5385 1.79097Z"
						fill="#2F2E46"
					></path>
					<path
						d="M32.8631 2.46822C33.4099 1.92149 34.2963 1.92149 34.843 2.46822L38.8028 6.42802C39.3496 6.97475 39.3496 7.86118 38.8028 8.40792L21.3314 25.8794C20.7846 26.4261 19.8982 26.4261 19.3515 25.8794L15.3917 21.9196C14.8449 21.3729 14.8449 20.4864 15.3917 19.9397L32.8631 2.46822Z"
						fill="#00DC5A"
					></path>
				</svg>
				<h3 className="color-secondary">Sencillo, BASIC</h3>
				<div className="home-plan-box__price color-primary">
					<p>{price}</p>
				</div>
				<div className="home-plan-box__description color-primary">
					<p>Simula el resultado de tu declaración</p>
				</div>
				<div className="home-plan-box__cta">
					<div className="button__container">
						<a
							href={PRICE_ROUTE}
							className="line_btn green no_sticky"
							data-testid="cta_button"
						>
							¡Vamos allá!
						</a>
					</div>
				</div>
			</div>
		);
	};

	const pro = (price) => {
		return (
			<div className="home-plan-box pro">
				<LogoYellow />
				<h3 className="color-gold">Como un PRO</h3>
				<div className="home-plan-box__price color-light">
					<p>{price}</p>
				</div>
				<div className="home-plan-box__description color-light">
					<p>Hazlo tu mismo y mejora tu resultado</p>
				</div>
				<div className="home-plan-box__cta">
					<a
						href={PRICE_ROUTE}
						className="line_btn gold no_sticky"
						data-testid="cta_button"
					>
						Más Información
					</a>
				</div>
			</div>
		);
	};

	const live = (price) => {
		return (
			<div className="home-plan-box live">
				<svg
					width="40"
					height="27"
					viewBox="0 0 40 27"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M6.3397 0.989949C6.88644 0.443215 7.77287 0.443216 8.3196 0.989949L12.2794 4.94975C12.8261 5.49648 12.8261 6.38291 12.2794 6.92965L7.32965 11.8794C6.78292 12.4261 5.89649 12.4261 5.34975 11.8794L1.38995 7.9196C0.84322 7.37286 0.84322 6.48643 1.38995 5.9397L6.3397 0.989949Z"
						fill="#3D3A62"
					></path>
					<path
						d="M19.5385 1.79097C20.0853 1.24424 20.9717 1.24424 21.5184 1.79097L25.4782 5.75077C26.025 6.29751 26.025 7.18394 25.4782 7.73067L14.3294 18.8795C13.7827 19.4262 12.8963 19.4262 12.3495 18.8795L8.38973 14.9197C7.843 14.3729 7.843 13.4865 8.38973 12.9398L19.5385 1.79097Z"
						fill="#3D3A62"
					></path>
					<path
						d="M32.8631 2.46822C33.4099 1.92149 34.2963 1.92149 34.843 2.46822L38.8028 6.42802C39.3496 6.97475 39.3496 7.86118 38.8028 8.40792L21.3314 25.8794C20.7846 26.4261 19.8982 26.4261 19.3515 25.8794L15.3917 21.9196C14.8449 21.3729 14.8449 20.4864 15.3917 19.9397L32.8631 2.46822Z"
						fill="#3D3A62"
					></path>
				</svg>
				<h3 className="color-primary">Con ayuda LIVE</h3>
				<div className="home-plan-box__price color-primary">
					<p>{price}</p>
				</div>
				<div className="home-plan-box__description color-primary">
					<p>Hazlo ayudado de los mejores expertos</p>
				</div>
				<div className="home-plan-box__cta">
					<a
						href={PRICE_ROUTE}
						className="line_btn no_sticky"
						data-testid="cta_button"
					>
						Más Información
					</a>
				</div>
			</div>
		);
	};

	const full = (price) => {
		return (
			<div className="home-plan-box full">
				<div className="featured">Próximamente</div>
				<LogoYellow />
				<h3 className="color-primary">Servicio FULL</h3>
				<div className="home-plan-box__price color-primary">
					<p>{price}</p>
				</div>
				<div className="home-plan-box__description color-primary">
					<p>Lo hacemos todo por ti</p>
				</div>
				<div className="home-plan-box__cta">
					<a
						href={PRICE_ROUTE}
						className="line_btn no_sticky"
						data-testid="cta_button"
					>
						Más información
					</a>
				</div>
			</div>
		);
	};
	const wrappers = document.getElementsByClassName(`my-block-wrapper`);
	for (let wrapper of wrappers) {
		const prices = [];
		for (let i = 0; i < wrapper.children.length; i++) {
			prices.push(wrapper.children[i].innerText);
		}
		render(
			<>
				<div className="home-plans-block__content">
					{basic(prices[0])}
					{pro(prices[1])}
					{live(prices[2])}
					{full(prices[3])}
				</div>
				<Slider {...settings}>
					{basic(prices[0])}
					{pro(prices[1])}
					{live(prices[2])}
					{full(prices[3])}
				</Slider>
			</>,

			wrapper
		);
	}
});
